import { render, staticRenderFns } from "./PgaOfferEvaluationHeaderInternalProjectCreate.vue?vue&type=template&id=a26ee554&"
import script from "./PgaOfferEvaluationHeaderInternalProjectCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationHeaderInternalProjectCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a26ee554')) {
      api.createRecord('a26ee554', component.options)
    } else {
      api.reload('a26ee554', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationHeaderInternalProjectCreate.vue?vue&type=template&id=a26ee554&", function () {
      api.rerender('a26ee554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationHeaderInternalProjectCreate.vue"
export default component.exports